import script from "./cclSuggestions.vue?vue&type=script&setup=true&lang=js"
export * from "./cclSuggestions.vue?vue&type=script&setup=true&lang=js"

import "./cclSuggestions.vue?vue&type=style&index=0&id=507d0873&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-507d0873"]])

export default __exports__